import { FiCheck } from '@react-icons/all-files/fi/FiCheck'
import { IoIosCheckmarkCircle } from '@react-icons/all-files/io/IoIosCheckmarkCircle'

// selected item, ok state

export const IconCheckMark = FiCheck
export const IconCheckMarkCircleFill = IoIosCheckmarkCircle
